import styled from "styled-components";

interface IDropdownProps {
  selected?: boolean;
}

export const Dropdown = styled.div`
  position: absolute;
  right: ${(props: IDropdownProps) => (props.selected ? "15px" : "20px")};
  top: 8px;
`;

export const DropdownTriggerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

interface IDropdownTriggerProps {
  selected?: boolean;
}

export const DropdownTrigger = styled.div`
  font-weight: 700;
  cursor: pointer;
  text-transform: capitalize;
  display: flex;
  padding: ${(props: IDropdownTriggerProps) =>
    props.selected ? "0" : "6px 0"};

  svg.fa-filter {
    margin-right: 10px;
    display: ${(props: IDropdownTriggerProps) => props.selected && "none"};
  }
`;

export const DropdownTriggerIconWrapper = styled.span``;

interface IDropdownTriggerInnerProps {
  selected?: boolean;
}

export const DropdownTriggerInner = styled.div`
  background-color: ${(props: IDropdownTriggerInnerProps) =>
    props.selected && "#f2008c"};
  color: ${(props: IDropdownTriggerInnerProps) => props.selected && "#fff"};
  padding: ${(props: IDropdownTriggerInnerProps) =>
    props.selected && "2px 10px"};
  font-size: ${(props: IDropdownTriggerInnerProps) =>
    props.selected ? "0.9em" : "0.94em"};
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
`;

export const ResetFilter = styled.div`
  position: relative;
  top: 2px;

  svg.fa-times {
    cursor: pointer;
    z-index: 5;
    background-color: #f2008c;
    padding: 5px 0px;
    height: 24px;
    color: #fff;
    width: 25px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

interface IDropdownOptionsProps {
  active?: boolean;
}

export const DropdownOptions = styled.div`
  position: absolute;
  top: 32px;
  cursor: pointer;
  width: 170px;
  text-align: left;
  box-shadow: rgb(214, 214, 214) 0px 0px 5px;
  opacity: 1;
  z-index: 5;
  right: ${(props: IDropdownOptionsProps) => (props.active ? "0" : "-150px")};
  opacity: ${(props: IDropdownOptionsProps) => (props.active ? "1" : "0")};
  pointer-events: ${(props: IDropdownOptionsProps) =>
    props.active ? "auto" : "none"};
  background: rgb(255, 255, 255);
  border-radius: 4px;
  transition: all 0.2s ease-in-out 0s;
  padding: 37.5px 5px 2.5px 5px;

  &::after,
  &::before {
    bottom: 100%;
    right: 15px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #eaeaea;
    border-width: 9px;
    margin-left: -2px;
  }
`;

export const Header = styled.div`
  position: absolute;
  font-size: 0.8em;
  top: 5px;
  border-bottom: 1px solid rgb(216, 216, 216);
  display: flex;
  flex: 1;
  width: 150px;
  margin: 0 5px;
  padding: 3px 7.5px;
  font-weight: 600;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 0.9em;
  top: 6px;
  right: 17.5px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #f2008c;
    }
  }
`;

export const DropdownOption = styled.div`
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  text-transform: capitalize;
  margin: 2.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  font-weight: 300;

  svg {
    position: absolute;
    right: 8px;
    top: 9px;
    font-size: 0.8em;
  }

  &:hover {
    background-color: #f2008c;
    color: #fff;
  }
`;
